var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5865 8.09114L5.26774 18.4099C4.7989 18.8787 4.5355 19.5146 4.5355 20.1776V23.3847H7.74261C8.40565 23.3847 9.04154 23.1214 9.51038 22.6525L19.8291 12.3338C20.6883 11.4746 20.6883 10.0817 19.8291 9.22251L18.6977 8.09114C17.8386 7.23199 16.4456 7.23199 15.5865 8.09114ZM6.5355 20.1776C6.5355 20.045 6.58818 19.9179 6.68195 19.8241L17.0007 9.50535C17.0788 9.42725 17.2054 9.42725 17.2835 9.50535L18.4149 10.6367C18.493 10.7148 18.493 10.8415 18.4149 10.9196L8.09616 21.2383C8.0024 21.3321 7.87522 21.3847 7.74261 21.3847L6.5355 21.3847L6.5355 20.1776Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.8492,
    y: 5.82843,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-45 17.8492 5.82843)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c4d68ef85b54f8cbbb4147978b6f3fc5.svg";
export { ForwardRef as ReactComponent };